import $ from 'jquery';
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import { convertDateToDdMmYyyy } from '@/function/function.js';
import EnteteBonEtFacture from '@/views/en-tete-bon-facture';

import ModalExamenBio from '@/views/consultations/en-cours/examen-bio-modal';
import ResultatsAnalysesFormTable from '@/views/analyse/resultats-analyses/saisie-resultats/components/ResultatsAnalysesFormTable';
import ResultatPatientModal from '@/views/analyse/registre_analyse/resultat-patient-modal'
import ManageResultatTDR from '@/views/analyse/manage-resultat-tdr'
import ShareConfirmationModal from '@/views/consultations/en-cours/confirm-sharing';
import SuiviAnalyse from '@/components/laboratoire/suivi-analyse';
import CompteRenduLaboratoire from '@/components/laboratoire/compte-rendu';
import store_laboratoire from '@/store/mods/analyses/laboratoire';

// LAB-001 : repli si le référentiel du laboratoire n'est pas chargé (mêmes valeurs que config/labo.php côté Clinique)
export const STATUTS_LABO_DEFAUT = {
    en_attente: { libelle: 'En attente de paiement', classe: 'badge-secondary' },
    a_prelever: { libelle: 'À prélever', classe: 'badge-warning' },
    preleve: { libelle: 'Prélevé', classe: 'badge-info' },
    recu: { libelle: 'Reçu au laboratoire', classe: 'badge-info' },
    en_analyse: { libelle: 'En analyse', classe: 'badge-primary' },
    a_saisir: { libelle: 'Technique terminée, à saisir', classe: 'badge-primary' },   // LAB-009
    saisi: { libelle: 'Résultat saisi', classe: 'badge-primary' },
    valide: { libelle: 'Validé et diffusé', classe: 'badge-success' },
    annule: { libelle: 'Annulé', classe: 'badge-danger' }
}

import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)

export default {
    name: 'examen-bio',
    components: {
        VueHtml2pdf,
        EnteteBonEtFacture, ModalExamenBio,
        ResultatsAnalysesFormTable, ResultatPatientModal,
        ManageResultatTDR, ShareConfirmationModal, SuiviAnalyse, CompteRenduLaboratoire
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        activeRole: String,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object,
        info_assurance_patient: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            vm_state: open_menu_state,
            drp_menu_class: [],

            format_analyse: 'a5', //  A5 (si prescriptions <= 6 ) ou A4 ( si prescription > 6)
            width_analyse: '559px',
            font_size: 'font-14',
            date_resultat: '', //  Date d'enregistrement du résultat
            filename: '',

            ver: null,
            demandes: [],
            demande: null,
            verdict: [
                {
                    libelle: "Positif",
                    state: true
                },
                {
                    libelle: "Négatif",
                    state: false
                }
            ],

            files: [],
            sv_loading: false,

            // LAB-001 : référentiel des statuts du circuit laboratoire et suivi d'une analyse
            referentiel_labo: null,
            suivi_demande: null,
            suivi_toggler: 0,
            // LAB-006 : compte rendu du bon (résultats validés et diffusés)
            compte_rendu_bulletin_id: 0,
            compte_rendu_toggler: 0,
            result_to_fill: {
                analyse_id: 0,
                analyse_nom: '',
                result_analyse: null
            },

            is_printing: false,
            bulletin_is_loading: true,
            bulletin_is_empty: false,
            load_error: false,
            is_new_bulletin: true,
            edit_bulletin: {
                bulletin_id: 0,
                ref_bon: '',
                analyses: []
            },

            bulletin_to_print: {},
            analyse_to_be_deleted: {},

            // TODO: Delete after confirmation
            examens: [
              { name: 'Vitesse de sédimentation', selected: true },
              { name: 'Hémoglobine', selected: true },
              { name: 'Glycémie', selected: true },
              { name: 'Cholestérol', selected: false },
            ],

            results: null,
            resultat_bulletin_id: 0,
            resultat_demande_id: 0,
            resultat_toggler: 0,
            selected_analyse: {},

            selected_demande: null,
            is_results_saving: false,
            show_print_results_button: false,

            result_meta_data: {
                patient_fullname: '',
                patient_age: '',
                patient_gender: '',
                patient_phone: '',
                doctor_fullname: '',
                clinical_inquiries: '',
                methodology_applied: '',
            },
            // pdfFilename: `resultats-analyse-${(new Date()).getTime()}.pdf`,
            show_results_errors: false,
            info_patient: {},
            info_caissier: {},

            view_result_loading: false,
            has_model: false,
            add_result_loading: false,
            can_print: false,
            info_user: {},
            toggler: 0,
            selected_analyse_info: {},

            sharing_target: {},
            sharing_label: "le résultat d'analyse",
            r_toggler: 0,
        }
    },

    watch: {
        demande_analyses() {
            this.demandes = this.demande_analyses
        },

        patient() {
            this.userInfoSetter()
        },

        user_info() {
            this.userInfoSetter()
        },

        evolution_toggler() {
            this.$store.commit("SET_BULLETIN_ANALYSES", []);
            this.$store.commit("SET_RESULAT_PATIENT_TO_PRINT", {})
            this.$store.commit("SET_CAN_PRINT_RESULT", false)
            this.$store.commit("SET_ADD_RESULT_LOADER", false);
            this.date_resultat = convertDateToDdMmYyyy.convertDate(new Date());

            let tm = new Date()
            this.filename = 'Bulletin Analyse_'+this.patient.nom+' '+this.patient.prenoms+'_'+tm.getTime()
            this.refreshExamenBio()

            this.userInfoSetter()

            this.$store.commit("SET_CAN_PRINT_ANALYSE", false)
            this.$store.commit("SET_ANALYSE_TO_PRINT", {})
        }
    },

    computed: {
        demande_analyses() {
            return this.$store.getters["demandeAnalyses"];
        },

        bulletin_analyses() {
            return this.$store.getters["bulletin_analyses"]
        },

        patient() {
            return this.$store.getters['patient'];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        },

        modeles_analyses() {
            return this.$store.getters["modeles_analyses"];
        },

        current_modele_analyse() {
            return this.$store.getters.current_modele_analyse
        },

        resultats_analyses() {
            return this.$store.getters.resultatsAnalyse
        },

        current_resultat_model() {
            return this.selected_analyse && this.selected_analyse.resultat_est_porte === 0 ? 'add' : 'edit';
        },

        selected_consultation_encours() {
            return this.$store.getters['selected_consultation_encours']
        },
    },

    mounted() {
        this._outsideClick = (event) => {
            if (!$(event.target).parents().hasClass('drp-container') && this.vm_state != 0) {
                this.openMenu(this.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
            }
        }
        $(document).on('click', this._outsideClick)
        this.userInfoSetter()
        this.charger_referentiel_labo()
        this.refreshExamenBio()
    },

    beforeDestroy() {
        $(document).off('click', this._outsideClick)
    },

    methods: {
        /**
         * LAB-001 : libellés et couleurs des statuts du circuit laboratoire (repli local si la Clinique ne répond pas)
         */
        charger_referentiel_labo() {
            return store_laboratoire.getReferentiel().then((response) => {
                if (response && response.success && response.data && response.data.statuts) {
                    this.referentiel_labo = response.data.statuts
                }
            }).catch(() => {
                this.referentiel_labo = null
            })
        },

        statut_labo(demande) {
            const statut = (demande && demande.statut) ? demande.statut : 'en_attente'
            const source = (this.referentiel_labo && this.referentiel_labo[statut]) ? this.referentiel_labo[statut] : STATUTS_LABO_DEFAUT[statut]
            if (!source) {
                return { libelle: statut, classe: 'badge-secondary' }
            }
            return { libelle: source.libelle, classe: source.classe }
        },

        ouvrir_suivi(demande, bulletin) {
            this.suivi_demande = {
                demande_id: demande.demande_id,
                nom: demande.nom,
                bulletin_id: bulletin ? bulletin.bulletin_id : 0
            }
            this.suivi_toggler = (this.suivi_toggler === 0) ? 1 : 0
            setTimeout(() => {
                $('.suivi-analyse-mdl').modal('show')
            }, 100)
        },

        // LAB-006 : le médecin ne voit que les résultats validés ; infobulle du validateur ; compte rendu du bon
        titre_statut_labo(demande) {
            if (!demande || demande.statut !== 'valide') return 'Voir le suivi laboratoire'
            const quand = demande.valide_at ? this.formatDateToDateHour(demande.valide_at) : ''
            return 'Validé et diffusé' + (demande.valide_par_nom ? ' par ' + demande.valide_par_nom : '') + (quand ? ' le ' + quand : '') + ' — voir le suivi'
        },

        bulletin_valide(bulletin) {
            return !!(bulletin && Array.isArray(bulletin.analyses) && bulletin.analyses.some(demande => demande.statut === 'valide'))
        },

        interpretation_biologiste(demande) {
            if (!demande || demande.statut !== 'valide') return ''
            return String(demande.interpretation_biologiste || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
        },

        resume_interpretation(demande) {
            const texte = this.interpretation_biologiste(demande)
            if (texte.length <= 110) return texte
            const fin = texte.lastIndexOf(' ', 110)
            return texte.slice(0, fin > 50 ? fin : 110).trim() + '…'
        },

        ouvrir_compte_rendu(bulletin) {
            this.compte_rendu_bulletin_id = bulletin.bulletin_id
            this.compte_rendu_toggler = (this.compte_rendu_toggler === 0) ? 1 : 0
        },

        // Contexte transmis avec une demande d'analyses (patient, médecin demandeur, caissier).
        // Recette du 03/10 : il n'était préparé qu'au changement d'évolution ; une demande faite
        // juste après l'ouverture partait sans sexe ni médecin. Il est maintenant préparé au montage,
        // à chaque changement de patient ou de médecin, et à l'ouverture de la fenêtre de demande.
        userInfoSetter() {
            const patient = this.patient || {}
            const medecin = this.user_info || {}
            const credentials = this.userCredentials || {}
            this.info_patient = {
                nom_patient: [patient.nom, patient.prenoms].filter(Boolean).join(' '),
                sexe: (patient.sexe_id == 1)?'M':(patient.sexe_id == 2)?'F':'',
                telephone: patient.telephone_mobile,
                num_dossier: patient.code,
                age: patient.age
            }

            this.info_caissier = {
                nom_caissier: credentials.name,
                titre: credentials.titre
            }

            this.info_user = {
                nom_medecin: medecin.user,
                titre: medecin.titre
            }
        },

        /**
         * Rafraichir les examens bio
         */
        refreshExamenBio() {
            this.$store.commit("SET_RESULAT_PATIENT_TO_PRINT", {})
            this.$store.commit("SET_CAN_PRINT_RESULT", false)
            this.$store.commit("SET_BULLETIN_ANALYSES", []);
            this.edit_bulletin = {
                bulletin_id: 0,
                ref_bon: '',
                renseignement_clinique: '',
                analyses: []
            }

            this.bulletin_is_loading = true
            this.load_error = false

            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.consultation.complement && Number(this.consultation.is_end) === 1
                    ? this.evolution_id : this.evolution_id_initiale,
                est_encours: true
            }

            return this.$store.dispatch('getBulletinAnalyses', data).then(() => {
                if (this.bulletin_analyses.length > 0) {
                    this.bulletin_is_empty = false
                } else {
                    this.bulletin_is_empty = true
                }
            }).catch(() => {
                this.load_error = true
            }).finally(() => {
                this.bulletin_is_loading = false
            })
        },

        formatText(str) {
            return str.replace('<br />', '\n')
        },

        demandeBulletin(is_new) {
            this.is_new_bulletin = is_new
            this.userInfoSetter()

            this.edit_bulletin = {
                bulletin_id: 0,
                ref_bon: '',
                renseignement_clinique: '',
                analyses: []
            }
        },

        editBulletin(b, evolution_id) {
            this.edit_bulletin = {
                evolution_id: evolution_id,
                bulletin_id: b.bulletin_id,
                ref_bon: b.ref_bon,
                analyses: b.analyses,
                renseignement_clinique: b.renseignement_clinique
            }
        },

        handleFilesUpload() {
            let uploadedFiles = this.$refs.files.files;
            /*
                Adds the uploaded file to the files array
            */
            this.files = []
            for (var i = 0; i < uploadedFiles.length; i++) {
                this.files.push(uploadedFiles[i]);
            }

            this.result_to_fill.result_analyse = this.files[0];
        },

        fillResult(demande, bulletin) {
            if (demande.nom == 'TDR Malaria') {
                this.toggler = (this.toggler == 0)?1:0
                this.selected_analyse = demande;
                this.selected_analyse_info = {
                    bulletin_id: bulletin.bulletin_id,
                    user_id: this.userCredentials.id,
                    evolution_id: this.evolution_id,
                    consultation_id: this.consultation.id
                }

                $('#manage-tdr-'+this.evolution_id).modal('show')
            } else {
                if (this.is_modele_analyse) {
                    this.fillModeleAnalyse(demande, bulletin)
                } else {
                    this.result_to_fill = {
                        demande_id: demande.demande_id,
                        analyse_nom: demande.analyse.nom,
                        analyse_commentaire: demande.commentaires
                    }
        
                    $('.fill-result'+this.evolution_id).modal('show')
                }
            }
        },

        fillModeleAnalyse(demande, bulletin) {
            this.add_result_loading = true
            
            this.result_to_fill = {
                demande_id: demande.demande_id,
                analyse_nom: demande.nom,
                analyse_commentaire: demande.commentaires
            }

            // this.selected_demande = demande;
            this.selected_analyse = demande;

            this.result_meta_data = {
                patient_id: this.patient.id,
                patient_fullname: this.patient.nom + ' ' + this.patient.prenoms,
                patient_age: this.patient.age,
                patient_gender: this.patient.sexe.specificatif,
                patient_phone: this.patient.telephone,
                doctor_fullname: bulletin.user,
                clinical_inquiries: bulletin.renseignement_clinique,
                methodology_applied: demande.technique_utilisee,
                bulletin_analyse_id: bulletin.bulletin_id,
                demande_analyse_id: demande.demande_id,   // LAB-004 : ligne de demande exacte pour la saisie et les pièces jointes
            }

            this.$store.dispatch("setPatientMetaData", this.result_meta_data);

            
            this.$store.commit("SET_ADD_RESULT_LOADER", true);
            this.$store.dispatch('fetchModelesAnalyses', { analyse_id: demande.analyse_id, status: 'active' }).then(() => {
                this.$store.dispatch("setResultatsAnalyse", null);//Réinitialisation des resultats
                this.add_result_loading = false
                this.has_model = true
                if (this.modeles_analyses.length === 0) {
                    this.has_model = false
                    this.$store.commit("SET_ADD_RESULT_LOADER", false);
                    $('#saisie-resultats-analyse-modal-' + this.evolution_id).modal('show');
                    
                    return;
                }
                
                if (demande.resultat_est_porte === 0) { // Nouveau
                    this.$store.commit("SET_ADD_RESULT_LOADER", false);
                    if (this.modeles_analyses.length > 1) {
                        this.$store.dispatch("setResultsMode", "add");
                        this.$refs['models-modal'].show();
                    } else if (this.modeles_analyses.length === 1) {
                        this.$store.dispatch("setResultsMode", "add");
                        this.$store.dispatch('setModeleAnalyse', this.modeles_analyses[0])

                        $('#saisie-resultats-analyse-modal-' + this.evolution_id).modal('show');
                    }
                } else {                                // Edition
                    //Récupérer les résultats pour cette analyse
                    const param = {
                        analyseId: demande.analyse_id,
                        bulletinId: bulletin.bulletin_id
                    }
                    this.$store.dispatch("getResultsByAnalyseIdBulletinId", param).then((response) => {
                        this.$store.commit("SET_ADD_RESULT_LOADER", false);
                        if (response.data.data && response.data.data.length > 0) {
                            this.$store.dispatch('setModeleAnalyse', this.modeles_analyses[0])
                            this.$store.dispatch("setResultsMode", this.current_resultat_model);
                            
                            this.selectModeleAnalyse(this.modeles_analyses[0])
                            
                            this.$store.dispatch('setResultatsAnalyse', response.data)
                        }
                    }) 
                }
            })
        },

        saveResultat() {
            this.sv_loading = true

            let data = {
                demande_id: this.result_to_fill.demande_id,
                commentaire: this.result_to_fill.analyse_commentaire,
                result_analyse: this.result_to_fill.result_analyse
            }

            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key])
            }

            this.$store.dispatch('saveAnalyseResult', form_data).then((response) => {
                if (response > 0) {
                    this.refreshExamenBio()
                    this.successToast("Résultat enregistré avec succès")

                    $('.modal').modal('hide')
                    this.sv_loading = false
                } else {
                    this.errorToast('Une erreur est survenue! Merci de réessayer.')
                }
            })
        },

        updateValueAction(demande) {
            this.$store.dispatch("updateTDR", { id: demande.id, data: demande, consultId: this.consultation.id }).then(
                () => {
                    if(demande.abreviation === 'TDR'){
                        this.successTDRupdated('TDR')
                    } else if (demande.abreviation === 'Alb') {
                        this.successTDRupdated('Albumine')
                    }

                }
            )
        },

        selectAnalyseUpload(demande) {
            this.demande = demande
        },

        successTDRupdated: function (param) {
            this.successToast('Le resultat de l\'analyse ' + param + ' a été mis à jour');
        },


        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        async deleteDemandeAnalyse(analyse, bulletin_id, evolution_id) {
            this.analyse_to_be_deleted = {
                bulletin_id: bulletin_id,
                demande_id: analyse.demande_id,
                libelle: analyse.nom,
                evolution_id: evolution_id,
                consultation_id: this.consultation.id,
                user_id: this.userCredentials.id
            }
        },

        // /**
        //  * 
        //  * @param {*} route 
        // */
        routeTo(route) {
            this.$router.push({ path: '/analyses/' + route })
        },

        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },


        /**
         * Imprimer une demande d'analyse
         */
        async printDemandeAnalyse(b) {
            this.$store.commit("SET_CAN_PRINT_ANALYSE", true)
            this.$store.commit("SET_ANALYSE_TO_PRINT", b)
        },

        setBulletinToDelete(b, evolution_id) {
            this.edit_bulletin = b
            this.edit_bulletin.evolution_id = evolution_id
        },

        async openResultsModal(demande_analyse, bulletin) {
            if (demande_analyse.statut && demande_analyse.statut !== 'valide') return
            if (demande_analyse.statut === 'valide' && bulletin && bulletin.bulletin_id && demande_analyse.demande_id) {
                this.resultat_bulletin_id = bulletin.bulletin_id
                this.resultat_demande_id = demande_analyse.demande_id
                this.resultat_toggler += 1
                return
            }
            const param_result = {
                demande_analyse: demande_analyse,
                evolution_id: this.evolution_id
            }

            if (!this.is_modele_analyse) {
                // this.demande = demande_analyse
                // this.results = null;
                // $('.view-result' + this.evolution_id).modal('show');

                this.results = null;
                this.$emit('emitViewOnGoingAnalyseResult', param_result)
            } else {
                if (demande_analyse.resultat_est_porte == 1 && demande_analyse.resultat_fichier != null) {
                    this.results = null;
                    this.$emit('emitViewOnGoingAnalyseResult', param_result)
                } else {
                    this.view_result_loading = true
                    $('#view-analysis-modal-'+this.evolution_id).modal('show');
    
                    const param = {
                        analyseId: demande_analyse.analyse_id,
                        bulletinId: bulletin.bulletin_id,
                    }
                    this.$store.dispatch("getResultsByAnalyseIdBulletinId", param).then((response) => {
                        this.results = response.data;
                        this.view_result_loading = false
                    })
                }
            }
        },

        selectModeleAnalyse(modele) {
            this.$store.dispatch('setModeleAnalyse', modele);
            this.$bvModal.hide(`model-list-modal-${this.evolution_id}`);

            const saisie_results = {
                data: Array.isArray(modele.meta.rows) ? this.setEditableFields(modele.meta.rows) : [],   // LAB-004 : modèles structurés ou document sans lignes
                model_analyse_id: this.current_modele_analyse.id,
            }

            this.$store.dispatch("setPatientMetaData", this.result_meta_data);
            this.$store.dispatch("setResultatsAnalyse", saisie_results);

            $('#saisie-resultats-analyse-modal-' + this.evolution_id).modal('show');
        },
        setEditableFields(modele_rows) {
            const rows = modele_rows;
            rows.forEach(row => {
                row.cells.forEach((cell, cellIndex) => {
                    if (cell.merged) { cell.editable = false; return; }
                    if (this.resultats_analyses === null && (cell.value === null || cell.value === '')) {
                        cell.editable = cellIndex !== 0 ? true : false;
                        if (cell.subcells && cell.subcells.length > 0) {
                            cell.subcells.forEach(subcell => {
                                if (subcell.value === null || subcell.value === '') {
                                    subcell.editable = true;
                                } else {
                                    subcell.editable = cellIndex !== 0 ? true : false;
                                }
                            });
                        }
                    } else {
                        cell.editable = false;
                        if (cell.subcells && cell.subcells.length > 0) {
                            cell.subcells.forEach(subcell => {
                                subcell.editable = false;
                            });
                        }
                    }
                });
            });

            return rows;
        },
        onCloseModal() {
            this.$store.dispatch("setResultatsAnalyse", null);
            this.refreshExamenBio();

            this.$refs.porter_resultats_analyse.click();
        },
        generateFilename(patientFullname) {
            const timestamp = new Date().getTime();
            const sanitizedFullname = (patientFullname || '').replace(/ /g, '_');
            return `Resultats-analyse-${sanitizedFullname}-${timestamp}.pdf`;
        },
        
        printResultatAnalyse(results) {
            this.$store.commit("SET_RESULAT_PATIENT_TO_PRINT", results)
            this.$store.commit("SET_CAN_PRINT_RESULT", true)
        },


        setSharingResult(demande_analyse, bulletin_id) {
            if (demande_analyse.statut && demande_analyse.statut !== 'valide') return
            console.log('demande_analyse', demande_analyse)
            this.r_toggler = (this.r_toggler == 0)?1:0
            this.sharing_target = demande_analyse 
            this.sharing_target.bulletin_id = bulletin_id

            $('#anl-result-sharer-'+this.evolution_id).modal('show')
        },
    },
}
